export default __webpack_public_path__ + "img/bb2c46d6292f79a80c7585be7b9827b8.svg";